import styled from "styled-components";

export const Layout = styled.div`
	ul {
		align-items: flex-start;
	}

	transition: 600ms ease-in-out;
	.close {
		width: 50px;
		align-items: flex-start;

		li {
			width: 0px;
			a {
				width: 0px;
				font-size: 0px;
				transition: ease;
			}
		}

		p {
			font-size: 0px;
		}
	}

	display: grid;
	grid-template-areas: "MN MC";
	grid-template-columns: 250px auto;
	padding: 10px;
	grid-gap: 20px;
	max-height: calc(100vh - 10px);
`;
